import { h } from 'preact';
import MenuItem from './menu-item';

const MainMenu = ({ menu, setShowBackDrop, setHeaderVoyagesLayout }) => {
  if (!menu) return null;

  return (
    <ul className="flex gap-[18px] tablet:gap-[22px] laptop:gap-4 desktop:gap-8  ml-[21px] tablet:ml-[30px] desktop:ml-[43px] h-full">
      {menu.map((link) => (
        <MenuItem
          link={link}
          key={`${link.title}-${link.url}`}
          setShowBackDrop={setShowBackDrop}
          setHeaderVoyagesLayout={setHeaderVoyagesLayout}
        />
      ))}
    </ul>
  );
};

export default MainMenu;
